import { createContext, useContext } from 'react';
import { RequestClient } from './request-client';
import { OSSRequestService } from './oss-request-service';
import axios from 'axios';
import { env } from '@/utils/shared/env';

/**
 * Create singleton instances for dependency injection
 */
const requestClient = new RequestClient(axios, env.VITE_OSS_URL + '/api');
const ossRequestService = new OSSRequestService(requestClient);

/**
 * React context for the OSS Request Service
 * Provides Angular-style dependency injection for the service
 */
export const RequestServiceContext = createContext<OSSRequestService>(ossRequestService);

/**
 * Custom hook to access the OSS Request Service
 * @returns The OSS Request Service instance
 */
export const useSearchService = (): OSSRequestService => {
    const context = useContext(RequestServiceContext);
    if (!context) {
        throw new Error('useApi must be used within a RequestServiceProvider');
    }
    return context;
};

export { ossRequestService };
